export default __webpack_public_path__ + "static/media/Front-Zambia-Offices.c82f07f6.jpg";